import { bootup } from "@app/bootup";
import { selectHasScheduledHas } from "@app/organizations";
import { useSelector } from "@app/react";
import { appServiceScalePathUrl } from "@app/routes";
import { schema } from "@app/schema";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { Loading } from "../shared";

/**
 * Gates the Scale v2 route behind the scheduled-HAS org allowlist.
 *
 * The selected org is not persisted to localStorage, so on a hard page load it
 * is empty until bootup resolves. We wait for that loader before deciding,
 * otherwise a direct URL visit would bounce an allowlisted user to v1.
 */
export const ScheduledHasEnabled = ({
  children,
}: { children?: React.ReactNode }) => {
  const { id = "", serviceId = "" } = useParams();
  const hasScheduledHas = useSelector(selectHasScheduledHas);
  const loader = useSelector((s) =>
    schema.loaders.selectById(s, { id: `${bootup}` }),
  );

  if (!loader.isSuccess) {
    return (
      <div className="flex w-full h-full items-center justify-center">
        <Loading />
      </div>
    );
  }

  if (!hasScheduledHas) {
    return <Navigate to={appServiceScalePathUrl(id, serviceId)} replace />;
  }

  return children ? children : <Outlet />;
};
